export const saveJson = (object: any, fileName: string) => {
  const fileData = JSON.stringify(object);
  const blob = new Blob([fileData], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = fileName;
  link.href = url;
  return link.click();
};
